import {useState} from 'react'
import Logo from '../logo.svg'
import { useNavigate } from "react-router";
import './css/find-factura.css';
export default function FindFactura() {
  const navigate = useNavigate();
const [hash, setHash] = useState('')
function goHash(e) {
  e.preventDefault()
   navigate(`/${hash}`); 
}


  return (
    <div className='Buscador'>
      <img src={Logo} alt="logo" />
      <span>Buscador de Facturas</span>
      <div><input type='text' placeholder='Hash...' onChange={(e)=> {setHash(e.target.value)}} /><button onClick={goHash} className='btn-blue'>Recuperar</button></div>
    </div>
  )
}
